const getters = {
	getConfiguratorData(state) {
		return state.configuratorData;
	},

	getProducts(state) {
		return state.products;
	},

	getExtras(state) {
		return state.extras;
	},

	getUpsells(state) {
		return state.upsells;
	},

	getTestimonials(state) {
		return state.testimonials;
	},

	getOrder(state) {
		return state.order;
	},
};

export { getters as default };
